/**
 * 模块说明
 * -------
 * 函数工具
 */
export default class Func {
    // 安全调用
    static pcall = async (func: Function, ...args: any[]) => {
        try {
            const response = func ? func(...args) : null;
            if (response instanceof Promise) return { value: await response };
            return { value: response };
        } catch (err) {
            return { err };
        }
    };

    // 递归处理
    static recursive = (
        key: string,
        source: Record<string, any>,
        format: (source: Record<string, any>) => Record<string, any>,
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    ): Record<string, any> | void => {
        if (!source) return;
        return {
            ...format(source),
            ...((source[key] && {
                [key]: Func.recursive(key, source[key], format),
            }) ||
                {}),
        };
    };

    // 捕获错误
    static catchError(...args: any[]) {
        for (const arg of args) {
            if (!arg) continue;
            if (arg instanceof Promise)
                arg.catch((e) => {
                    if (process.env.NODE_ENV !== 'production') console.error(e);
                });
        }
    }
}
